module.exports = __webpack_public_path__ + "fcfcd789d5e788b5b26c162a5731d6ac.png";